export var IconButtonVariantType;
(function (IconButtonVariantType) {
    IconButtonVariantType["PRIMARY"] = "PRIMARY";
    IconButtonVariantType["PRIMARY_FILLED"] = "PRIMARY_FILLED";
    IconButtonVariantType["SECONDARY"] = "SECONDARY";
    IconButtonVariantType["SECONDARY_FILLED"] = "SECONDARY_FILLED";
    IconButtonVariantType["TERTIARY"] = "TERTIARY";
    IconButtonVariantType["MAIN_SECTION"] = "MAIN_SECTION";
    IconButtonVariantType["SECONDARY_MAIN_SECTION"] = "SECONDARY_MAIN_SECTION";
    IconButtonVariantType["PRIMARY_ON_SURFACE"] = "PRIMARY_ON_SURFACE";
    IconButtonVariantType["SECONDARY_ON_SURFACE"] = "SECONDARY_ON_SURFACE";
    IconButtonVariantType["CONTACT_CENTER_PRIMARY"] = "CONTACT_CENTER_PRIMARY";
    IconButtonVariantType["CONTACT_CENTER_SECONDARY"] = "CONTACT_CENTER_SECONDARY";
})(IconButtonVariantType || (IconButtonVariantType = {}));
export var IconButtonSizeType;
(function (IconButtonSizeType) {
    IconButtonSizeType["SMALL"] = "SMALL";
    IconButtonSizeType["MEDIUM"] = "MEDIUM";
    IconButtonSizeType["LARGE"] = "LARGE";
})(IconButtonSizeType || (IconButtonSizeType = {}));
//# sourceMappingURL=iconButton.js.map